import { atom } from 'recoil';

export const toggleQuickConfig = atom({
    key: 'pc-windows-toggleQuickConfig',
    default: false,
});

export const quickConfigDetails = atom({
    key: 'pc-windows-quickConfigDetails',
    default: undefined,
});

export const defaultVmDataDisk = atom({
    key: 'pc-windows-defaultVmDataDisk',
    default: undefined,
});

export const toggleSspModels = atom({
    key: 'pc-windows-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isDiskOpen: false,
        isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
    },
});

export const isEnvDetailsLoading = atom({
    key: 'pc-windows-isEnvDetailsLoading',
    default: false,
});

export const isDataDiskLoaded = atom({
    key: 'pc-windows-isDataDiskLoaded',
    default: false,
});

export const isConfigDiskFulfilled = atom({
    key: 'pc-windows-isConfigDiskFulfilled',
    default: false,
});

export const defaultOsDiskType = atom({
    key: 'pc-windows-defaultOsDiskType',
    default: undefined,
});

export const isMandatoryTagsFullfilled = atom({
    key: 'pc-windows-isMandatoryTagsFullfilled',
    default: false,
});

export const orderId = atom({
    key: 'pc-windows-orderId',
    default: '',
});

export const isValidOwners = atom({
    key: 'pc-windows-isValidOwners',
    default: {
        isvalidAppOwner: true,
    },
});

export const sspSubmitOrder = atom({
    key: 'pc-windows-sspOrder',
    default: {
        // Application Section
        appProfile: null,
        entityDetails: null,
        sector: null,
        sectorDetail: null,
        environment: null,
        landingZoneDetails: null,
        region: 'Dallas Data Center',
        dtc: 'Dallas Data Center',
        hCode: null,
        hCodeDetails: null,
        appOwner: null,
        appOwnerDetails: null,
        appTier: null,
        appTierCode: null,
        businessCategory: null,
        dataClassification: null,

        // Resource Section
        clusterDetails: null,
        clusterName: null,
        clusterVlans: [],
        vlanDetails: null,
        vlanName: null,
        osImage: null,
        osName: null,
        osDisplayName: null,
        cpu: null,
        memoryGiB: null,
        quantity: 1,
        maxDataDiskCount: 8,
        dataDisksCount: null,
        dataDisks: [],
        defaultDataDisks: [],
        timeZone: null,
        displayTimeZone: null,
        billingEntity: null,
        billingEntityDetails: null,

        // Access Management Section
        domain: null,
        adous: null,
        adousDetails: null,
        adGroup: null,

        tags: [],
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time',
                estCost: null,
                currency: 'USD',
            },
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
        },
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const costEstimateState = atom({
    key: 'pc-windows-costEstimateState',
    default: null,
});

export const isLoadingCostApiState = atom({
    key: 'pc-windows-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const showisExistADGrp = atom({
    key: 'pc-windows-showisExistADGrp',
    default: false,
});

export const isCostcenterValid = atom({
    key: 'pc-windows-isCostcenterValid',
    default: false,
});
